import { STORES_CORRECTION_KINDS } from "@nexseed/shared";
import { createFileRoute, redirect } from "@tanstack/react-router";
import { z } from "zod";
import { FormPageSkeleton } from "@/components/app/skeletons";
import { useAuth } from "@/features/auth/store";
import { useFacilities } from "@/features/auth/use-facilities";
import { CorrectionPage } from "@/features/stores/components/correction-page";

export const Route = createFileRoute("/_app/stores/corrections/new")({
  validateSearch: z.object({
    kind: z.enum(STORES_CORRECTION_KINDS).default("good_to_damage"),
  }),
  beforeLoad: () => {
    if (!useAuth.getState().can("stores.correct"))
      throw redirect({ to: "/stores/corrections" });
  },
  component: Page,
});

function Page() {
  const { kind } = Route.useSearch();
  const { selected, ready } = useFacilities();
  if (!ready) return <FormPageSkeleton />;
  return (
    <CorrectionPage
      key={kind}
      kind={kind}
      doc={null}
      facilityId={selected?.id}
      plantName={selected ? `${selected.name} (${selected.plantCode})` : null}
    />
  );
}
